"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Types_1 = require("../../../../../Types");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
var Util_1 = require("../../../../../Services/Util");
var Endpoints_1 = require("../../../../../Utils/Endpoints");
var Services_1 = require("../../../../../Services");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var PasswordData = /** @class */ (function () {
    function PasswordData(p1, p2) {
        this.Password1 = p1;
        this.Password2 = p2;
    }
    PasswordData.match = function (data) {
        return data.Password1 != "" && data.Password2 != "" && data.Password1 == data.Password2;
    };
    return PasswordData;
}());
var ArvatoChangePasswordEventContentState;
(function (ArvatoChangePasswordEventContentState) {
    ArvatoChangePasswordEventContentState[ArvatoChangePasswordEventContentState["Initial"] = 0] = "Initial";
    ArvatoChangePasswordEventContentState[ArvatoChangePasswordEventContentState["Confirm"] = 1] = "Confirm";
    ArvatoChangePasswordEventContentState[ArvatoChangePasswordEventContentState["Pending"] = 2] = "Pending";
    ArvatoChangePasswordEventContentState[ArvatoChangePasswordEventContentState["Success"] = 3] = "Success";
    ArvatoChangePasswordEventContentState[ArvatoChangePasswordEventContentState["Error"] = 4] = "Error";
})(ArvatoChangePasswordEventContentState || (ArvatoChangePasswordEventContentState = {}));
var ArvatoChangePasswordEventContent = /** @class */ (function (_super) {
    __extends(ArvatoChangePasswordEventContent, _super);
    function ArvatoChangePasswordEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.changePassword = function () {
            _this.updateModal(ArvatoChangePasswordEventContentState.Pending);
            var body = JSON.stringify({ location: _this.props.locationName, password: encodeURI(_this.state.passwordData.Password1) });
            Util_1.postJson(Endpoints_1.default.ArvatoChangePassword, body, undefined, true, new Util_1.UserRequestHeaders(__assign(__assign({}, Services_1.Auth.getUser()), { Location: _this.props.applicationData.selectedLocation })), true)
                .then(function () {
                _this.updateModal(ArvatoChangePasswordEventContentState.Success);
            })
                .catch(function (err) {
                var _a;
                _this.updateModal(ArvatoChangePasswordEventContentState.Error);
                _this.setState({
                    error: React.createElement("div", null, (_a = err.value, (_a !== null && _a !== void 0 ? _a : err)).split(/(?:[.]{1}[ ]{1})/gm).map(function (value, index, array) {
                        return React.createElement("div", null,
                            value,
                            index !== array.length - 1 && React.createElement("br", null));
                    }))
                });
            });
        };
        _this.goNext = function () {
            _this.updateModal(ArvatoChangePasswordEventContentState.Confirm);
        };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            switch (newState) {
                case ArvatoChangePasswordEventContentState.Initial:
                    event.title = _this.props.applicationData.resources.ChangePassword;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Next, "primary", function () {
                            _this.goNext();
                        }, true), new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ArvatoChangePasswordEventContentState.Confirm:
                    event.title = _this.props.applicationData.resources.Confirm;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Yes, "primary", function () {
                            _this.changePassword();
                        }), new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.No, "danger", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ArvatoChangePasswordEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.applicationData.resources.LoadingDotDotDot;
                    event.actions = [];
                    break;
                case ArvatoChangePasswordEventContentState.Success:
                    event.title = _this.props.applicationData.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
                case ArvatoChangePasswordEventContentState.Error:
                    event.title = _this.props.applicationData.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.applicationData.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    break;
            }
            eventHandler.UpdateEvent();
        };
        _this.validatePassword = function (event, key) {
            event.persist();
            _this.setState(function (prevState) {
                var _a;
                var _b;
                return {
                    passwordData: __assign(__assign({}, prevState.passwordData), (_a = {}, _a[key] = (_b = event.target) === null || _b === void 0 ? void 0 : _b.value, _a))
                };
            }, function () {
                _this.setState(function (prevState) {
                    var _a;
                    return {
                        changePasswordValidation: __assign(__assign({}, prevState.changePasswordValidation), (_a = {}, _a[key] = prevState.changePasswordValidation[key].validate(prevState.passwordData[key]), _a))
                    };
                });
            });
        };
        _this.matchPasswords = function (event, key) {
            event.persist();
            _this.setState(function (prevState) {
                var _a;
                return {
                    passwordData: __assign(__assign({}, _this.state.passwordData), (_a = {}, _a[key] = event.target.value, _a))
                };
            }, function () {
                _this.setState(function (prevState) {
                    var _a;
                    return {
                        changePasswordValidation: __assign(__assign({}, prevState.changePasswordValidation), (_a = {}, _a[key] = prevState.changePasswordValidation[key].validate(_this.state.passwordData[key], PasswordData.match(_this.state.passwordData)), _a))
                    };
                });
            });
        };
        _this.state = {
            status: ArvatoChangePasswordEventContentState.Initial,
            error: "",
            changePasswordValidation: {
                Password1: new Types_1.InputValidation(true, props.applicationData.resources.ValidationError_PasswordInvalid, /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/gm),
                Password2: new Types_1.InputValidation(true, props.applicationData.resources.ValidationError_PasswordsDontMatch)
            },
            passwordData: new PasswordData("", "")
        };
        return _this;
    }
    ArvatoChangePasswordEventContent.prototype.componentDidUpdate = function () {
        if (this.state.status === ArvatoChangePasswordEventContentState.Initial) {
            var passwordsAreValid = !this.state.changePasswordValidation.Password1.isInvalid() && PasswordData.match(this.state.passwordData);
            var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
            var event = eventHandler.GetEvent();
            if (event.actions[0].isDisabled && passwordsAreValid) {
                event.actions[0].isDisabled = false;
                eventHandler.UpdateEvent();
            }
            else if (!event.actions[0].isDisabled && !passwordsAreValid) {
                event.actions[0].isDisabled = true;
                eventHandler.UpdateEvent();
            }
        }
    };
    ArvatoChangePasswordEventContent.prototype.render = function () {
        var _this = this;
        switch (this.state.status) {
            case ArvatoChangePasswordEventContentState.Initial:
                return (React.createElement("div", null,
                    this.props.applicationData.resources.ArvatoChangePassword_InitialMessage,
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                        React.createElement(reactstrap_1.Input, { valid: this.state.changePasswordValidation.Password1.isValid(), invalid: this.state.changePasswordValidation.Password1.isInvalid(), onChange: function (e) { return _this.validatePassword(e, "Password1"); }, value: this.state.passwordData.Password1, type: "password" }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.changePasswordValidation.Password1.isInvalid() ? this.state.changePasswordValidation.Password1.Validation.Error : "")),
                    React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                        React.createElement(reactstrap_1.Input, { valid: this.state.changePasswordValidation.Password2.isValid(), invalid: this.state.changePasswordValidation.Password2.isInvalid(), onChange: function (e) { return _this.matchPasswords(e, "Password2"); }, value: this.state.passwordData.Password2, type: "password" }),
                        React.createElement(reactstrap_1.FormFeedback, { style: { textAlign: "right" } }, this.state.changePasswordValidation.Password2.isInvalid() ? this.state.changePasswordValidation.Password2.Validation.Error : ""))));
            case ArvatoChangePasswordEventContentState.Confirm:
                return this.props.applicationData.resources.ArvatoChangePassword_ComfirmMessage;
            case ArvatoChangePasswordEventContentState.Pending:
                return (React.createElement(Components_1.CustomSpinner, null));
            case ArvatoChangePasswordEventContentState.Success:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.props.applicationData.resources.ArvatoChangePassword_SuccessMessage),
                        React.createElement(reactstrap_1.Col, null))));
            case ArvatoChangePasswordEventContentState.Error:
                return (React.createElement("div", null,
                    React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" },
                            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                        React.createElement(reactstrap_1.Col, null)),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null),
                        React.createElement(reactstrap_1.Col, { xs: "auto" }, this.state.error),
                        React.createElement(reactstrap_1.Col, null))));
        }
    };
    return ArvatoChangePasswordEventContent;
}(React.Component));
exports.ArvatoChangePasswordEventContent = ArvatoChangePasswordEventContent;
//# sourceMappingURL=ArvatoChangePasswordEventContent.js.map